<template>
  <div class="tab-six-rl">
    <el-form class="form-wrapper" label-width="80px">
      <el-form-item label="状态">
        <el-select
          v-model="local_filter_state"
          multiple
          collapse-tags
          placeholder="请选择(支持多选)"
        >
          <el-option
            v-for="item in kStateOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-button @click="filterAction" style="margin-left: 10px" type="primary"
        >筛选</el-button
      >
    </el-form>
    <el-table
      v-loading="loading"
      :data="lists"
      style="width: 100%"
      empty-text="暂无数据"
    >
      <el-table-column prop="rl_name" label="推荐人" align="center" />

      <el-table-column prop="" label="写作构思" align="center">
        <template slot-scope="scope">
          <el-link
            v-if="scope.row.writing_conception"
            type="primary"
            @click="detailInfoDialog = scope.row.writing_conception"
            >查看</el-link
          >
          <p v-else>--</p>
        </template>
      </el-table-column>
      <el-table-column prop="" label="类型" align="center">
        <template slot-scope="scope">
          <p v-if="scope.row.type == 'rl'">机构上传</p>
          <p v-if="scope.row.type == 'rl_user'">学生上传</p>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="文书" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.name">
            <el-link
              type="primary"
              @click="
                () => {
                  previewUrl = scope.row.upload_documents[0].url;
                  previewName = scope.row.upload_documents[0].name;
                }
              "
            >
              预览/下载
            </el-link>
            <p v-if="scope.row.document_status==1" style="color: red;margin: 0">[终稿]</p>
            <p v-if="scope.row.document_status==2" style="color: red;margin: 0">[草稿,请勿确认]</p>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="文书记录" prop="" align="center">
        <template slot-scope="scope">
          <el-link type="primary" @click="logDocumentRl(scope.row)"
            >查看</el-link
          >
        </template>
      </el-table-column> -->
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.is_institution_write==2">
            推荐人自己写填写RL
          </div>
          <div v-else>
            <p v-if="scope.row.status == 3" style="color: #f56c6c">待确认</p>
            <p v-if="scope.row.status == 1" style="color: #08a0eeff">已确认</p>
            <el-link
              v-if="scope.row.status == 2"
              type="danger"
              @click="reasonRejectionUserSchoolChoice(scope.row.content,scope.row.reject_type)"
            >已驳回，待老师修改</el-link
            >
            <p v-if="scope.row.status == 0" style="color: #f56c6c">待老师上传</p>
          </div>
        </template>
      </el-table-column>


<!--      <el-table-column prop="status" label="是否自己写RL" align="center" sortable>-->
<!--        <template slot-scope="scope">-->
<!--          <div v-if="scope.row.is_institution_write==1">-->
<!--            <el-popconfirm-->
<!--              title="确定改为推荐人自己写填写RL？"-->
<!--              @confirm="-->
<!--                updateInstitutionWrite(-->
<!--                  scope.row.id,-->
<!--                  2,-->
<!--                  scope.row.rl_id-->
<!--                )-->
<!--              "-->
<!--            ><el-button slot="reference"  size="mini"-->
<!--            >机构填写</el-button-->
<!--            ></el-popconfirm-->
<!--            >-->
<!--          </div>-->
<!--          <div v-if="scope.row.is_institution_write==2">-->
<!--            <el-popconfirm-->
<!--              title="确定改为机构填写RL？"-->
<!--              @confirm="-->
<!--                updateInstitutionWrite(-->
<!--                  scope.row.id,-->
<!--                  1,-->
<!--                  scope.row.rl_id-->
<!--                )-->
<!--              "-->
<!--            ><el-button slot="reference"  size="mini"-->
<!--            >推荐人填写</el-button-->
<!--            ></el-popconfirm-->
<!--            >-->
<!--          </div>-->
<!--        </template>-->
<!--      </el-table-column>-->



      <el-table-column label="操作" prop="" align="center">
        <template slot-scope="scope">
          <div
            class="operation"
          >
            <div v-if="scope.row.is_institution_write==1" >
              <div class="btns-wrapper">
                <el-popconfirm
                  class="btn"
                  title="是否确认？"
                  @confirm="updateStatus(scope.row.id, 1)"
                  v-if="scope.row.status == 3"
                >
                  <el-button slot="reference" size="mini" type="primary"
                    >确认</el-button
                  >
                </el-popconfirm>
                <el-button
                  class="btn"
                  v-if="scope.row.status == 3"
                  size="mini"
                  type="danger"
                  @click="refuseUserSchoolChoice(scope.row.id)"
                  >驳回</el-button
                >
              </div>
            </div>
            <div v-if="scope.row.is_institution_write == 2" >
              <el-button v-if="scope.row.status == 0" size="mini" @click="addDocumentRl(scope.row)"
              >上传rl</el-button
              >
              <el-button
                v-if="
                  scope.row.status == 3 ||
                  scope.row.status == 2 ||
                  scope.row.status == 1
                "
                size="mini"
                type="primary"
                @click="editDocumentRl(scope.row)"
              >修改</el-button
              >
            </div>
          </div>

<!--          <div v-if="scope.row.is_institution_write==2">-->
<!--            <el-button v-if="!scope.row.name"  size="mini" @click="addDocumentRl(scope.row)">上传rl</el-button>-->
<!--            <el-button v-else  size="mini" @click="editDocumentRl(scope.row)">修改</el-button>-->
<!--          </div>-->
        </template>
      </el-table-column>
      <el-table-column prop="updated_at" label="更新时间" align="center" />
    </el-table>
    <reject ref="reject" @reject="getList" :needFile="true"></reject>

    <!--文书上传弹窗-->
    <show_document ref="showDocument" />
    <!--文书显示弹窗-->
    <upload_document ref="uploadDocument" @show_list="getList" />
    <reason_rejection ref="reason_rejection"></reason_rejection>
    <HBFilePreview
      :previewUrl="previewUrl"
      :fileName="previewName"
      @updateVisible="
        previewUrl = null;
        previewName = null;
      "
    />
    <el-dialog
      center
      title="查看"
      :visible="detailInfoDialog"
      width="50%"
      :before-close="() => (detailInfoDialog = null)"
    >
      <p style="white-space: pre-wrap; font-size: 16px">
        {{ detailInfoDialog }}
      </p>
    </el-dialog>
  </div>
</template>
<script>
import {
  document_list,
  del_document,
  user_information_document_edit,
  update_institution_write
} from "@/api/mycenter_studyabroad";
import show_document from "./show_document";
import upload_document from "./upload_document";
import reject from "./reject";
import { downloadFile } from "@/api/file";
import reason_rejection from "./reason_rejection";
import HBFilePreview from "@/components/HBCommon/HBFilePreview/HBFilePreview";
export default {
  name: "TabSixRl",
  components: {
    show_document,
    upload_document,
    reject,
    reason_rejection,
    HBFilePreview,
  },
  data() {
    return {
      local_filter_state: [],
      detailInfoDialog: null,
      previewUrl: null,
      previewName: null,
      refuseId: "", // 驳回id
      reason: "", // 拒绝理由
      dialogAddUserSchoolChoice: false,
      dataSource: [],
      lists: [], // 数据列表
      requestData: {
        type: "rl",
        loading: "",
      },
      content: {
        title: "",
        type: "",
        name: "",
        operate: "",
        id: "",
      },
    };
  },
  computed: {
    kStateOptions() {
      return [
        {
          label: "已驳回",
          value: 2,
        },
        {
          label: "待确认",
          value: 3,
        },
        {
          label: "已确认",
          value: 1,
        },
        {
          label: "待老师上传",
          value: 0,
        },
      ];
    },
  },
  created() {
    this.getList();
  },
  methods: {
    updateInstitutionWrite(id, state) {
      update_institution_write(id,state)
        .then(() => {
          this.$message.success("状态更新成功");
          this.getList();
        })
        .catch((error) => {
          this.$message.error(error.message);
        });
    },
    filterAction() {
      if (!this.local_filter_state || this.local_filter_state.length == 0) {
        this.lists = this.dataSource;
        return;
      }
      const resultList = [];
      const stateList = this.local_filter_state || [];

      this.dataSource.forEach((item) => {
        var flag = true;

        if (stateList.length > 0 && !stateList.includes(item.status)) {
          flag = false;
        }
        if (flag == true) {
          resultList.push(item);
        }
      });
      this.lists = resultList;
    },
    downLoad(url, name) {
      downloadFile(url, name);
    },
    refuseUserSchoolChoice(id) {
      this.$refs.reject.sendItem(id, "rl", 2);
    },
    updateStatus(id, status) {
      var reason = this.reason;
      user_information_document_edit({
        id: id,
        con: reason,
        status: status,
        type: "rl",
      }).then((response) => {
        this.dialogAddUserSchoolChoice = false;
        this.getList();
      });
    },
    reasonRejectionUserSchoolChoice(content,reject_type) {
      content = JSON.parse(content);
      this.$refs.reason_rejection.sendItem(content.content, content.url,reject_type);
    },
    getList() {
      this.loading = true;
      document_list(this.requestData)
        .then((response) => {
          this.loading = false;
          const dataList = response.data || [];
          this.dataSource = dataList;
          this.lists = dataList;
          this.filterAction();
        })
        .catch((error) => {});
    },
    addDocumentRl(item) {
      this.content.type = "rl_user";
      this.content.id = item.id;
      this.content.operate = "add";
      this.content.title = "添加rl";
      this.$refs.uploadDocument.sendItem(this.content);
    },
    editDocumentRl(item) {
      this.content.type = "rl_user";
      this.content.id = item.id;
      this.content.name = item.name.substring(0, item.name.indexOf("-"));
      this.content.operate = "edit";
      this.content.title = "修改rl";
      this.$refs.uploadDocument.sendItem(this.content);
    },
    logDocumentRl(content) {
      this.$refs.showDocument.sendItem(content.upload_documents);
    },
    delDocumentRl(id) {
      del_document({ id: id, type: "rl_user" }).then((response) => {
        this.getList(true);
      });
    },
  },
};
</script>
<style scoped lang="scss">
.tab-six-rl {
  .form-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    .el-form-item {
      margin-bottom: 0 !important;
    }
  }
  .btns-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    .btn {
      margin-bottom: 5px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/tab_six_rl.vue